<div class="mt-20">
  <articles application="DOSS" [canEdit]="canEditArticles()" [published]="canEditArticles ? undefined : true"></articles>
</div>

